import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormsService, CatalogService, UserService } from 'src/app/services/service.index';
import { prestamo } from 'src/app/models/paciente.model';
import { Observable, Subject, concat, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, catchError, map } from 'rxjs/operators';
import { medico } from 'src/app/models/medico.model';
import { user } from 'src/app/models/authorization.model';

@Component({
  selector: 'app-devoluciones-dialog',
  templateUrl: './devoluciones-dialog.component.html',
  styles: []
})
export class DevolucionesDialogComponent implements OnInit {
  @ViewChild("form", { static: true }) form;
  @Output() submit_form = new EventEmitter<FormGroup>();
  @Output() close_modal = new EventEmitter();
  @Input()  show_cancel_button: boolean = false;
  @Input()  prestamo: prestamo= new prestamo({});
  @Input()  user: user;
  options: any = [{label:'Si', value:true}, {label:'No', value:false}];
  modal_devoluciones_form: FormGroup;
  areas:any;
  camas:any;
  rowData: any = [];
  personal$: Observable<Object>;
  personalInput$ = new Subject<string>();
  personalLoading = false;
  bandVisble:boolean =  false;

  constructor(private _fb: FormBuilder, public _frm:FormsService,public _cat2: CatalogService,public usersCat: UserService) { }

  ngOnInit() {
    this.modal_devoluciones_form = this._fb.group({
      prestamo_id:[this.prestamo.prestamo_id, [Validators.required]],
      paciente_id: [this.prestamo.paciente_id, [Validators.required]],
      fecha_prestamo: [this.prestamo.fecha_prestamo],
      fecha_devolucion_real: [this.prestamo.fecha_devolucion_real],
      fecha_devolucion_programada: [this.prestamo.fecha_devolucion_programada],
      observaciones: [this.prestamo.observaciones],
      personal_entrega_id: [this.prestamo.personal_entrega_id],
      personal_recibe_id: [this.prestamo.personal_recibe_id],
      personal_devuelve_id: [this.prestamo.personal_devuelve_id],
      area_id: [this.prestamo.area_id],
      cama_id: [this.prestamo.cama_id]
    });
    this.loadPersonal();


  }
  on_submit() {
    this.submit_form.emit(this.modal_devoluciones_form);
  }
  on_close() {
    this.close_modal.emit();
  }

  private loadPersonal() {
    this.personal$ = concat(
      of(
        this.prestamo.personal_recibe_id?
          [{ nombre_completo: this.prestamo.personal_recibe, person_id: this.prestamo.personal_recibe_id }] : []
        ),
      this.personalInput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => this.personalLoading = true),
        switchMap(term => this.usersCat.get_personal_catalog(term).pipe(
          catchError(() => of([])),
          tap(() => this.personalLoading = false),
        ))
      )
    )
  }

}
